(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"]) return;
  try {
    
  document.querySelectorAll('.collection-subcategories-wrapper').forEach((wrapper) => {
    const track = wrapper.querySelector('.collection-subcategories');
    const update = () => {
      wrapper.classList.toggle('is-scrollable', track.scrollWidth > track.clientWidth + 1);
      wrapper.classList.toggle(
        'is-scrolled-end',
        track.scrollLeft + track.clientWidth >= track.scrollWidth - 1
      );
    };

    wrapper.querySelector('.collection-subcategories__scroll').addEventListener('click', () => {
      track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(track);
  });

  } catch(e) { console.error(e); }
})();
})();
